import * as R from 'ramda';
import axios from 'axios';

function getLatestVersion() {
    return axios
        .get('/deploy.json', {
            headers: {
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache',
                Expires: 0,
            },
        })
        .then(R.path(['data', 'commit_hash']));
}

export { getLatestVersion };
